import { Button, Grid, InputAdornment, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputForm from "../../../partials/inputForm";
import { getNumberOnString } from "../../../partials/validateNumber";
import DescriptionComponent from "../../descriptionComponent";
import Dialog from "../../dialog";
import InputFileReader from "../../fileReader";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import SelectMenu from "./selectMenu";
import { editMenuItemStyles } from "./styles";
class EditMenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: 0,
      data: {
        title: "",
        price: 0,
        priceShow: "",
        description: "",
        itemTime: 0,
        position: 0,
        menuId: `[]`,
        image: "",
      },
    };
    this.handleDialog = this.handleDialog.bind(this);
  }
  componentDidMount() {
    let _this = this;
    this.setState({ data: Object.assign({}, this.props.data) }, function () {
      _this.DescriptionComponent.changeDescription(this.props.data.description);
    });
  }

  componentWillReceiveProps(nextProps) {
    let _this = this;
    if (this.props.data !== nextProps.data) {
      this.setState({ data: Object.assign({}, nextProps.data) }, function () {
        _this.DescriptionComponent.changeDescription(
          nextProps.data.description
        );
      });
    }
  }

  handleChange = (event) => {
    let target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    let name = target.name;
    let data = this.state.data;
    if (name === "priceShow") value = getNumberOnString(value);
    data[name] = value;
    this.setState({ data });
  };

  handleSelectSuportChange = (value) => {
    let data = this.state.data;
    data.support = value;
    this.setState({ data }, function () {});
  };

  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };

  handleSubmit = async () => {
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let { data = {} } = this.state;

    data.menuId = this.selectMenu.getData(); // Những menu item chưa assign group sẽ có value là ''

    if (this.InputFileReader.getFile() !== null) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: this.InputFileReader.getFile(),
        imgPre: this.state.data.image,
        code: this.props.serviceCode,
        type: "img-menu-item",
      });
      if (checkUpload.code === 1) {
        data.image = checkUpload.data.previewLink;
      } else {
        data.image = "";
        if (data.message) this.mSnackbar.handleClick(data.message, "warning");
      }
    } else if (this.InputFileReader.getSrc() !== null) {
      data.image = this.InputFileReader.getSrc();
    } else if (this.InputFileReader.getFile() === null) {
      if (this.state.data.image && this.InputFileReader.getFlagEdit()) {
        data.image = "";
      }
    }

    this.handleEdit(data);
  };
  handleEdit = async (data = {}) => {
    let checkUpdate = await this.props.serviceMenuItemDispatch.editMenuItem(
      data
    );
    this.loading.stopLoading();
    this.props.finishAction(
      checkUpdate.code === 1 ? checkUpdate.code : checkUpdate.message
    );
  };
  handleDialog() {
    this.mDialog.handleDialogOpen();
  }
  render() {
    const { classes, t, disabled = false } = this.props;
    const { data = {} } = this.state;
    console.log(data);
    if (Object.keys(this.state.data).length > 0) {
      return (
        <form className={classes.container} noValidate autoComplete="off">
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Dialog
            onRef={(dialog) => (this.mDialog = dialog)}
            disagree={t("menu_menuitem_editmenuitem_cancel")}
            agree={t("menu_menuitem_editmenuitem_yes")}
            title={t("menu_menuitem_editmenuitem_confirm")}
            content={t(
              "menu_menuitem_editmenuitem_are_you_sure_you_want_to_change_in_menu_item"
            )}
            action={this.handleSubmit}
          />

          <Loading onRef={(id) => (this.loading = id)} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <InputForm
                disabled={disabled}
                required
                label="Code"
                name="code"
                value={data.code}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                label={t("menu_menuitem_editmenuitem_title")}
                name="title"
                value={data.title === null ? (data.title = "") : data.title}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                label={t("menu_menuitem_editmenuitem_price")}
                name="price"
                value={
                  data.price === null ? (data.price = 0) : Number(data.price)
                }
                onChange={this.handleChange}
                fullWidth={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {t("menu_menuitem_editmenuitem_minute")}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                label={t("menu_menuitem_addmenuitem_price_to_show_on_web")}
                name="priceShow"
                value={data.priceShow}
                onChange={this.handleChange}
                fullWidth={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {t("menu_menuitem_editmenuitem_minute")}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                type="number"
                label={t("menu_menuitem_editmenuitem_time")}
                name="itemTime"
                value={data.itemTime || ""}
                onChange={this.handleChange}
                fullWidth={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {t("menu_menuitem_editmenuitem_minute")}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                type="number"
                label={t("menu_menuitem_editmenuitem_position")}
                name="position"
                value={
                  data.position === null ? (data.position = "") : data.position
                }
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                select
                fullWidth={true}
                label={t("show_on_shop")}
                name="showOnShop"
                value={data.showOnShop}
                onChange={this.handleChange}
              >
                <MenuItem value={1}>{t("show")}</MenuItem>
                <MenuItem value={0}>{t("hide")}</MenuItem>
              </InputForm>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputForm
                disabled={disabled}
                select
                label={t("is_show_price")}
                name="isShowPrice"
                value={data.isShowPrice}
                fullWidth={true}
                onChange={this.handleChange}
              >
                <MenuItem value={1}>{t("show")}</MenuItem>
                <MenuItem value={0}>{t("hide")}</MenuItem>
              </InputForm>
            </Grid>
            <Grid item xs={12} sm={12} md={12} className={classes.flexGroup}>
              <SelectMenu
                label={"menu"}
                disabled={disabled}
                onRef={(id) => (this.selectMenu = id)}
                menuId={data.menuId ? JSON.parse(data.menuId) : []} // Nếu menuId là chuỗi rỗng thì truyển mảng rỗng
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <DescriptionComponent
                disabled={disabled}
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("menu_menuitem_editmenuitem_description")}
                handleSubComponentChange={this.handleSubComponentChange}
                description={data.description}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <InputFileReader
                disabled={disabled}
                container="square"
                onRef={(id) => (this.InputFileReader = id)}
                style={classes}
                defaultImg={data.image || "/images/noneImage.svg"}
                selectStorageMode={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container justify="flex-end">
                <Button
                  disabled={disabled}
                  onClick={this.handleSubmit}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                >
                  {t("menu_menuitem_editmenuitem_save")}
                </Button>
              </Grid>
            </Grid>
            {/* </Grid>
            </Grid> */}
          </Grid>
        </form>
      );
    } else {
      return <div></div>;
    }
  }
}

EditMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceState: state.service,
  serviceCode: state.user.user.roleId.serviceCode,
  settingState: state.setting,
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});

const mapDispatch = (dispatch) => ({
  serviceMenuItemDispatch: dispatch.serviceMenuItem,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(editMenuItemStyles)(EditMenuItem)));
